export default "__VITE_ASSET__bb63442c__$_?used__"